import React from 'react';
import { Col, Form } from 'react-bootstrap';

const FormFile = ({ title, classes, required, handleChange }) => {
      return (
            <>
                  <Form.Group as={Col} lg={classes ? classes : 6}>
                        <Form.Label>
                              {title}{' '}
                              {required && (
                                    <span className="text-danger">*</span>
                              )}
                        </Form.Label>
                        <Form.Control
                              type="file"
                              onChange={(event) =>
                                    handleChange(event.target.files[0])
                              }
                              required={required}
                        />
                  </Form.Group>
            </>
      );
};

export default FormFile;
